<div class="modal-overlay"></div>

<div class="wrapper">
    @if (showBackButton) {
        <button class="icon icon-arrow-back" (click)="backClicked.emit()"></button>
    }

    <div class="header">
        <h2 i18n>{{ title }}</h2>

        @if (virtualToggleButtonVisible) {
            <div class="filter">
                <app-button-group [buttons]="virtualToggleButtons" (clicked)="filterGames($event)"></app-button-group>
            </div>
        }
    </div>

    <div
        class="games"
        [class.games-push-down]="virtualToggleButtonVisible"
        [class.grid-columns-1]="filteredGamesPerPage.length === 1"
        [class.grid-columns-2]="filteredGamesPerPage.length === 2"
    >
        @for (game of filteredGamesPerPage; track game.id) {
            <button i18n class="button-game" [class.button-game-selected]="game.id === currentGameId" (click)="gameSelected.emit(game.id)">
                {{ game.displayName }}
            </button>
        }
    </div>

    @if (pagesCount > 1) {
        <app-pagination [totalPages]="pagesCount" [(pageIndex)]="pageIndex" (pageIndexChange)="updatePageIndex($event)"></app-pagination>
    }
</div>
